export const footerColumns = [
  {
    heading: "Quick Links",
    links: [
      { label: "Our Story", to: "/about" },
      { label: "Careers", to: "/careers" },
    ],
  },
  {
    heading: "Services",
    links: [
      { label: "Transportation", to: "/transportation" },
      { label: "Warehousing", to: "/warehouse" },
      { label: "Machinery", to: "/machinery" },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
      { label: "F.A.Q", to: "/faq" },
    ],
  },
];

export const socialLinks = [
  { label: "Facebook", icon: "FaFacebookF", href: "#" },
  { label: "LinkedIn", icon: "FaLinkedinIn", href: "#" },
  { label: "Twitter", icon: "FaXTwitter", href: "#" },
];

export const mapEmbedUrl =
  "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d510565.3633491013!2d36.820191!3d-1.299669!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f10e3f05157df%3A0x6fe3154c5f0c2ccb!2sLower%20Hill%20Duplex%20Building%2C%20Bunyala%20Rd%2C%20Nairobi%2C%20Kenya!5e0!3m2!1sen!2sus!4v1729667962047!5m2!1sen!2sus";
